// extracted by mini-css-extract-plugin
export default {"button":"IconButton_button__cO2ou","label":"IconButton_label__6J69a"};